__turbopack_context__.v({
  "active": "premarket-module__WfUyrW__active",
  "bold": "premarket-module__WfUyrW__bold",
  "divider": "premarket-module__WfUyrW__divider",
  "footer": "premarket-module__WfUyrW__footer",
  "hide": "premarket-module__WfUyrW__hide",
  "tab": "premarket-module__WfUyrW__tab",
  "tabs": "premarket-module__WfUyrW__tabs",
});
